import { ShareStoryMeta, ShareStoryPayload } from 'types/store/ShareStory';
import { createAsyncReducer } from 'utils/Redux';

import { shareStoryActions } from '../actions';

export default createAsyncReducer<ShareStoryMeta, ShareStoryPayload>(shareStoryActions);
